import {
  createContext,
  useContext,
  useState,
  useMemo,
  PropsWithChildren,
} from 'react';

interface ReportCardContextType {
  activeTabKey: number;
  setActiveTabKey: (tabKey: number) => void;
}

const ReportCardContext = createContext<ReportCardContextType | undefined>(
  undefined,
);

export const useReportCard = () => {
  const context = useContext(ReportCardContext);
  if (!context) {
    throw new Error('useReportCard must be used within a ReportCardProvider');
  }
  return context;
};

export const ReportCardProvider = ({ children }: PropsWithChildren) => {
  const [activeTabKey, setActiveTabKey] = useState<number>(1);

  const contextValue = useMemo(
    () => ({ activeTabKey, setActiveTabKey }),
    [activeTabKey],
  );

  return (
    <ReportCardContext.Provider value={contextValue}>
      {children}
    </ReportCardContext.Provider>
  );
};
